import {
	AfterViewInit,
	Component,
	ElementRef,
	HostBinding,
	inject,
	Input,
	OnDestroy,
	viewChild,
	ChangeDetectionStrategy,
} from "@angular/core";
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";

@Component({
	selector: "stages-fit-to-page",
	templateUrl: "./fit-to-page.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ["./fit-to-page.component.scss"],
})
export class FitToPageComponent implements AfterViewInit, OnDestroy {
	private readonly resizeObserver: ResizeObserver;
	private hostElement = inject(ElementRef);
	private sanitizer = inject(DomSanitizer);

	private _fitToPage: boolean = true;

	@HostBinding("class.zoom") bindStyle: boolean = !this._fitToPage;

	// TODO: Skipped for migration because:
	//  Accessor inputs cannot be migrated as they are too complex.
	@Input("fitToPage")
	set fitToPage(value: boolean) {
		this._fitToPage = value;
		this.bindStyle = !this._fitToPage;
		this.update();
	}

	readonly contentWrapper = viewChild.required<ElementRef>("contentWrapper");

	fitToPageScale?: SafeStyle;

	constructor() {
		this.resizeObserver = new ResizeObserver((entries) => {
			this.update();
		});
	}

	ngAfterViewInit(): void {
		this.update();
		this.resizeObserver.observe(this.hostElement.nativeElement);
	}

	ngOnDestroy(): void {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}
	}

	private update(): void {
		const scalingFactor = this._fitToPage ? this.calculateScalingFactor() : 1;
		const scale = scalingFactor < 1 ? scalingFactor : 1;
		this.fitToPageScale = this.sanitizer.bypassSecurityTrustStyle(
			`translate(-50%, -50%) scale(${scale}) translate(50%, 50%)`,
		);
	}

	private calculateScalingFactor(): number {
		return determineWidth(this.hostElement) / determineWidth(this.contentWrapper());
	}
}

function determineWidth(elementRef: ElementRef): number {
	const htmlElem = elementRef.nativeElement as HTMLElement;
	return htmlElem.offsetWidth;
}
